
document.addEventListener("DOMContentLoaded", function () {
    const reviewForm = document.querySelector("#commentform");

    if (!reviewForm) return;

    const submitButton = reviewForm.querySelector("#submit");
    const commentField = reviewForm.querySelector("#comment");
    const ratingElement = reviewForm.querySelector("#rating");

    if (!submitButton) return;

    submitButton.addEventListener("click", function (e) {
        e.preventDefault();

        const comment = commentField ? commentField.value.trim() : "";
        const rating = ratingElement ? ratingElement.value : "";

        // Remove previous validation messages.
        reviewForm.querySelectorAll(".review-error-message").forEach(error => {
            error.remove();
        });

        let hasError = false;

        // Require a written review only when the comment field exists.
        // if (commentField && comment === "") {
        //     const commentContainer = commentField.closest(".comment-form-comment");
        //
        //     if (commentContainer) {
        //         const errorDiv = document.createElement("p");
        //         errorDiv.classList.add("review-error-message");
        //         errorDiv.style.color = "red";
        //         errorDiv.style.marginTop = "5px";
        //         errorDiv.textContent = "Please enter a review.";
        //
        //         commentContainer.appendChild(errorDiv);
        //     }
        //
        //     hasError = true;
        // }

        // Require a rating for both guests and logged-in users.
        if (ratingElement && rating === "") {
            const errorDiv = document.createElement("p");
            errorDiv.classList.add("review-error-message");
            errorDiv.style.color = "red";
            errorDiv.style.marginTop = "5px";
            errorDiv.textContent = "Please select a rating.";

            ratingElement.parentNode.appendChild(errorDiv);
            hasError = true;
        }

        if (hasError) {
            submitButton.disabled = false;
            return;
        }

        submitButton.disabled = true;

        console.log("Submitting review...");

        // Submit the form without triggering the click handler again.
        reviewForm.requestSubmit();
    });

    // Clear comment errors when the user types.
    if (commentField) {
        commentField.addEventListener("input", function () {
            if (commentField.value.trim() !== "") {
                reviewForm.querySelectorAll(".review-error-message").forEach(error => {
                    error.remove();
                });

                submitButton.disabled = false;
            }
        });
    }

    // Clear errors when a rating is selected.
    if (ratingElement) {
        ratingElement.addEventListener("change", function () {
            reviewForm.querySelectorAll(".review-error-message").forEach(error => {
                error.remove();
            });

            submitButton.disabled = false;
        });
    }
});
